import React, { useState } from "react";
import { Sparkles, X, Sun, Flame, KanbanSquare, Bell, Plug } from "lucide-react";

const STEPS = [
  { icon: Sun, title: "Commencez par « Aujourd'hui »", text: "Votre centre de travail quotidien : prospects chauds à contacter, relances du jour, rendez-vous et clients à risque." },
  { icon: Flame, title: "Priorités IA", text: "Chaque prospect reçoit un score intelligent (chaud / tiède / froid). Cliquez sur « Analyse IA » pour un résumé et la prochaine action." },
  { icon: KanbanSquare, title: "Pipeline & soumissions", text: "Glissez vos opportunités entre les étapes, générez des soumissions PDF et convertissez une soumission acceptée en projet PROGÈRE ERP." },
  { icon: Bell, title: "Relances automatiques", text: "Le CRM détecte les soumissions sans réponse, les clients inactifs et crée les relances. Consultez le centre de notifications (cloche)." },
  { icon: Plug, title: "Écosystème PROGÈRE", text: "Connecté à PUNCH, ERP, COMPTA, PAIE et DEVIS AI. Un client actif peut être lié à un chantier PROGÈRE PUNCH." },
];

export function OnboardingAI() {
  const [open, setOpen] = useState(() => !localStorage.getItem("pg_onboarded"));
  const [step, setStep] = useState(0);
  if (!open) return null;

  const close = () => { localStorage.setItem("pg_onboarded", "1"); setOpen(false); };
  const s = STEPS[step];
  const last = step === STEPS.length - 1;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4">
      <div className="absolute inset-0 backdrop-blur-md bg-black/70" onClick={close} />
      <div className="relative w-full max-w-md bg-[#141414] border border-white/10 rounded-2xl p-6 pg-fade-up" data-testid="onboarding-modal">
        <button onClick={close} className="absolute top-4 right-4 text-gray-500 hover:text-white transition-colors" data-testid="onboarding-close"><X size={18} /></button>
        <div className="flex items-center gap-2 mb-4">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-[#F2BC2E] to-[#F10D19] flex items-center justify-center"><Sparkles size={17} className="text-black" /></div>
          <span className="font-display font-bold text-white">Assistant PROGÈRE IA</span>
        </div>
        <div className="bg-[#0f0f0f] border border-white/5 rounded-xl p-4">
          <div className="flex items-center gap-2 mb-2"><s.icon size={18} className="text-[#F2BC2E]" /><h3 className="font-semibold text-white">{s.title}</h3></div>
          <p className="text-sm text-gray-400 leading-relaxed">{s.text}</p>
        </div>
        <div className="flex items-center justify-between mt-5">
          <div className="flex gap-1.5">{STEPS.map((_, i) => <span key={i} className={`w-2 h-2 rounded-full transition-colors ${i === step ? "bg-[#F2BC2E]" : "bg-white/15"}`} />)}</div>
          <div className="flex gap-2">
            {step > 0 && <button onClick={() => setStep(step - 1)} className="text-sm text-gray-400 px-3 py-2 hover:text-white transition-colors">Précédent</button>}
            <button onClick={() => (last ? close() : setStep(step + 1))} data-testid="onboarding-next" className="btn-gold rounded-full px-5 py-2 text-sm">{last ? "Commencer" : "Suivant"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
